import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AdminAuthContext";

export const PublicRoute = ({ children }) => {
  const { auth } = useAuth();

  if (auth) {
    if (auth.role === "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    }

    if (auth.role === "maintainer") {
      return <Navigate to="/admin/dashboard" replace />;
    }

    if (auth.role === "member") {
      return <Navigate to="/member-profile" replace />;
    }
    if (auth.role === "student") {
      return <Navigate to="/student-profile" replace />;
    }
  }

  return <>{children}</>;
};
